module.exports = __webpack_public_path__ + "img/scene2-img.8727fbb4.png";